import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, gradient } from "@clockwise/web-commons/src/styles/color.styles";
import { standardStyles } from "@components/suggestion-card-header/SuggestionCardHeader.styles";
const { topLine } = standardStyles;

const container: CSSProperties = {
  ...standardStyles.container,
};

const headerBody: CSSProperties = {
  ...standardStyles.body,
  paddingBottom: 15,
  borderBottom: container.borderBottom,
};

const header: CSSProperties = {
  marginBottom: 0,
};

const suggestionsContainer: CSSProperties = {
  backgroundColor: greys.palePaleGrey,
  width: "100%",
  overflowX: "hidden",
  position: "relative",
};

const suggestions: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  height: 265,
  transition: "transform 500ms ease-in-out",
};

const explosion: CSSProperties = {
  position: "absolute",
  zIndex: 1,
  height: 265,
  width: "100%",
  opacity: 0,
  background: gradient,
  animation: "$exploding 500ms ease-out",
};

export const getSuggestionOffsetStyles = (index: number) => {
  const SUGGESTION_WIDTH = 279;
  return {
    transform: `translateX(${SUGGESTION_WIDTH * -1 * index}px)`,
  };
};

export const styles = {
  topLine,
  container,
  headerBody,
  header,
  suggestionsContainer,
  suggestions,
  explosion,
  "@keyframes exploding": {
    "0%": {
      opacity: 1,
    },
    "20%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
};
